import { render, staticRenderFns } from "./ConfigTableSSR.vue?vue&type=template&id=08393890"
import script from "./ConfigTableSSR.vue?vue&type=script&lang=js"
export * from "./ConfigTableSSR.vue?vue&type=script&lang=js"
import style0 from "./ConfigTableSSR.vue?vue&type=style&index=0&id=08393890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports